import { withTranslation } from "next-i18next";
import useCustomizableCloset from "@hooks/use-customizable-closet";
import ClosetItemsList from "@components/core/ClosetItemsList";

function DrawerClosetSent({ t }) {
  const currentCloset = useCustomizableCloset();

  return (
    <div>
      <div className="d-flex flex-column align-items-center bg-white py-3 px-4 text-center gap-2">
        <h5 className="px-2 mb-0">
          {t('common:drawer.modal_closet_sent.imminent_arrival')}
        </h5>
        <p className="px-2 mb-0 text-gray">
          {t('common:drawer.modal_closet_sent.your_closet_has_been_shipped')}
        </p>
        {currentCloset.delivery_follow_up_url && (
          <a
            className="link-primary mx-auto no-underline"
            href={currentCloset.delivery_follow_up_url}
            target="_blank"
            rel="noreferrer"
          >
            {t("common:drawer.modal_closet_sent.follow_closet_delivery")}
          </a>
        )}
      </div>

      <div className="m-2">
        <ClosetItemsList closet={currentCloset} />
      </div>
    </div>
  );
};

export default withTranslation("common")(DrawerClosetSent);
